<template>
  <v-snackbar v-model="showingComputed" :timeout="timeout" :color="color" centered>
    <div
      class="text-center"
      :class="[
        smallerText ? 'text-small' : 'text-h6',
        showCloseBtn ? 'mr-9' : 'mr-0'
      ]"
    >
      {{ text && text.split("errorCode: ")[0] }}
      <v-btn
        v-if="showCloseBtn"
        class="closeSnackBar"
        icon
        text
        @click="$emit('closeSnackBar')"
      >
        <v-icon>fa-times-circle</v-icon>
      </v-btn>
    </div>
    <div class="text-center caption">
      {{ text && text.split("errorCode: ")[1] }}
    </div>
    <div
      class="py-auto d-flex justify-center"
      v-if="support && color === 'error'"
    >
      <v-btn text @click="$emit('openChat')">
        <span class="mr-2"><v-icon>fa-headset</v-icon></span>
        {{ $t("Chat with support") }}
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",
  props: {
    timeout: {
      type: Number,
      default: 4000
    },
    showing: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "primary"
    },
    text: {
      type: String
    },
    confirmation: {
      //currently not used anymore in the template
      type: String
    },
    support: { // show a button that allows the user to initiate a chat with support
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    smallerText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showingComputed: {
      get() {
        return this.showing
      },
      set(value) {
        if (!value) this.$emit('closeSnackBar')
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.closeSnackBar {
  position: absolute;
  top: 8px;
  right: 16px;
  font-size: 18px;
}
</style>
